module.exports = __webpack_public_path__ + "static/media/mercury.22866672.svg";